import { render, staticRenderFns } from "./InfoWidget.vue?vue&type=template&id=20838318&scoped=true&"
import script from "./InfoWidget.vue?vue&type=script&lang=ts&"
export * from "./InfoWidget.vue?vue&type=script&lang=ts&"
import style0 from "./InfoWidget.vue?vue&type=style&index=0&id=20838318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20838318",
  null
  
)

export default component.exports